module.exports = __webpack_public_path__ + "static/media/Facebook_Logo_Primary.e4da2370.png";